// Video Review Status Enum - matches the Ruby enum string values
export const VideoReviewStatus = {
  PENDING: "pending",
  UPLOADING: "uploading",
  PROCESSING: "processing",
  COMPLETED: "completed",
  APPROVED: "approved",
  REJECTED: "rejected",
  FAILED: "failed"
}
